import { render, staticRenderFns } from "./update-action.vue?vue&type=template&id=65b918bb"
import script from "./update-action.vue?vue&type=script&lang=js"
export * from "./update-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports